module.exports = __webpack_public_path__ + "assets/img/appDefault.5f4333bc.svg";